import { TextInput } from '@app/components';
import { StyledForms } from '@app/components/styled/form/Form';
import React from 'react';

export const OrderCancelReasonForm = () => {
  return (
    <StyledForms.Form>

      <TextInput
        name="reason"
        label="Raison"
        autoCapitalize="none" />

    </StyledForms.Form>
  );
};
